import React, { useEffect } from 'react'
import { AgentCard, BasicButton, FormBlock } from '../components'
import { useState } from 'react'
import services from '../../ioc/services';
import ModalContainer from './ModalContainer';
import AddAgentForm from './Forms/AddAgentForm';

function AgentsContainer() {

    const [agents, setAgents] = useState([]);

    const [editing, setEditing] = useState(false);

    const [deleting, setDeleting] = useState(false);

    const [editData, setEditData] = useState(null);

    const [deleteData, setDeleteData] = useState(null);

    useEffect(() => {
        services.api.agent.getAgents().then(res => {
            setAgents(res)
        });
    }, [])

    const displayhandleAgentEdit = (agent) => {

        const agentEditData = {
            id: agent._id,
            firstName: agent.firstName,
            lastName: agent.lastName,
            email: agent.user.email,
            phoneNumber: agent.phoneNumber,
            location: agent.location ?? "",
            adminId: agent.created_by ?? ""
        }

        setEditData(agentEditData)

        setEditing(true);

    }

    const displayhandleAgentdelete = (agent) => {

        const agentEditData = {
            id: agent._id,
            user_id: agent.user_id,
            firstName: agent.firstName,
            lastName: agent.lastName,
        }

        setDeleteData(agentEditData)

        setDeleting(true);

    }

    const handleAgentDelete = () => {

        services.api.auth.deleteUser({ user: deleteData.user_id })
            .then(res => {
                services.alert.toast.success("Agent Deleted Successfully");
                window.location.reload();
            })
            .catch(err => services.alert.toast.error(err))
    }

    return (
        <>
            <div className=' grid grid-cols-4 gap-4'>
                {agents.map(agent => <AgentCard
                    agent={agent}
                    key={agent.id}
                    handleEditClick={() => displayhandleAgentEdit(agent)}
                    handleDeleteClick={() => displayhandleAgentdelete(agent)}
                />)}
            </div>
            <ModalContainer title="Edit Agent Details" isOpen={editing} setIsOpen={setEditing}>
                {/* <AddAgentForm /> */}
                <AddAgentForm isEdit={true} agentData={editData} />
            </ModalContainer>

            {deleting && <ModalContainer
                title="Delete Agent"
                isOpen={deleting}
                setIsOpen={setDeleting}
                contentStyle={
                    {
                        maxWidth: '500px',
                        maxHeight: '300px',
                        margin: 'auto',
                    }
                }
            >
                <div>
                    <p className=' text-center'>Are you sure you want to delete  {deleteData.firstName} {deleteData.lastName}?</p>

                    <div className=' grid justify-around grid-cols-2 gap-8 items-center mt-12'>
                        <button
                            onClick={handleAgentDelete}
                            className='bg-red-400 text-white text-sm rounded-lg py-2 px-6'>Yes</button>
                        <button
                            onClick={() => setDeleting(false)}
                            className='bg-slate-500 text-white text-sm rounded-lg py-2 px-6'>No</button>
                    </div>
                </div>

            </ModalContainer>}
        </>
    )
}

export default AgentsContainer